import { WidgetsServicesReportListMain } from '@/widgets/services-report-list';

export const PagesServicesProverkaMain = () => (
  <WidgetsServicesReportListMain reportType="PROVERKA" />
);
